import { render, staticRenderFns } from "./AddArmazem.vue?vue&type=template&id=30f5c0a6"
import script from "./AddArmazem.vue?vue&type=script&lang=js"
export * from "./AddArmazem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports